// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b5fbc69e","239":"48e447a7","732":"a31d3a00"}[chunkId] + ".chunk.js";
};